var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationGroup',{style:(_vm.position.topRight)},[_c('Fade',{attrs:{"appear":_vm.visible}},[(_vm.visible)?_c('Notification',{attrs:{"type":_vm.notificationType}},[_c('span',[_vm._v(_vm._s(_vm.content))])]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }